import React from "react";
import { Box, Stack, IconButton, Typography } from "@mui/material";
import MusicRow from "../../components/MusicRow";
import PageHeader from "./../../components/PageHeader";
import BottomSheet from "../../components/BottomSheet";
import { useSelector, useDispatch } from "react-redux";
import {
  addSongAction,
  addSongsAction,
  clearSong,
  removeSong,
} from "./../../action/songs";
import { useHistory } from "react-router-dom";
import AddMusicToPlaylist from "./../../components/AddMusicToPlaylist";
import { Images } from "../../assets/common";
import DropMenu from "./../../components/DropMenu";
import OutsideClickHandler from "react-outside-click-handler";
import { useTranslation } from "react-i18next";
import { getUserId, putStreamRecord } from "../../constants/function";
export default function PlayQueue({
  handleClose,
  onRedirect,
  playingIndex,
  handleSelectedId,
  handleShowPlaylist,
  currentPlayTime,
}) {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const history = useHistory();
  const songs = useSelector((state) => state.songs);

  const [selectedId, setSelectedAlbum] = React.useState();
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [showPlaylist, setShowPlaylist] = React.useState(false);

  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (value, id, index) => {
    setOpen(value);
    setSelectedIndex(index);
    if (id) {
      handleSelectedId(id);
      setSelectedAlbum(id);
      setSelectedIndex(index);
    }
    if (value && id) makeAction(value, id, index);
  };
  const makeAction = (key, id, index) => {
    switch (key) {
      case "m1":
        handleClose();
        songs["songs"][index]?.nftId
          ? history.push(`/app/SongDetail/${songs["songs"][index]?.nftId}`)
          : history.push(`/app/SongDetails/${id}`);
        break;
      case "m3":
        setShowPlaylist(true);
        handleShowPlaylist(true);
        break;
      case "m25":
        if (songs && songs["songs"].length === 1) {
          dispatch(clearSong());
          handleClose(null);
        } else {
          dispatch(removeSong(index));
          setOpen(false);
        }
        break;
      default:
        break;
    }
  };
  const clear = () => {
    if (songs && songs["songs"].length > 0) {
      dispatch(clearSong());
      handleClose(null);
    }
  };
  React.useEffect(() => {
    if (songs && songs["songs"].length === 0) history.push("/app/Library");
  }, [songs]);

  //click the clear button then throw the kinesis stop event
  const currentSong = songs.songs[songs.index];

  const stopEvent = () => {
    putRecord(
      "stop",
      currentSong?._id,
      currentSong?.playlistId,
      playingIndex,
      currentPlayTime,
      new Date().getTime(),
      currentSong?.albumId
    );
  };

  const putRecord = (
    event,
    musicId,
    playlistId,
    index,
    timeInSong,
    associationId,
    albumId
  ) => {
    const userId = getUserId();
    const payload = {
      eventType: event,
      timestamp: new Date().getTime(),
      userId: userId,
      musicId: musicId,
      playlistId: playlistId,
      livestreamId: null,
      songDetails: songs[index],
      timeInSong: timeInSong,
      associationId: associationId,
      sessionId: "sessionId",
      albumId: albumId,
    };
    putStreamRecord(payload);
  };

  return (
    <Box>
      <Stack
        direction="row"
        sx={{ padding: "10px" }}
        justifyContent="space-between"
      >
        <IconButton onClick={() => handleClose()}>
          <img
            style={{ width: "12px", height: "12px" }}
            src={Images.arrow_down}
            alt="arrow_down"
          />
        </IconButton>
        <Typography className="fs-20">{t("playQueue.header")}</Typography>
        <Stack
          direction="row"
          alignItems="center"
          gap="10px"
          onClick={() => {
            clear();
            stopEvent();
          }}
          className="_cp"
        >
          <img style={{ width: "15px" }} src={Images.clear} alt="clear" />
          <Typography className="fs-14 _cp">{t("playQueue.button")}</Typography>
        </Stack>
      </Stack>
      <Box sx={{ padding: "0 18px 0 18px" }}>
        <Stack
          spacing={2}
          sx={{
            height: "50vh",
            maxHeight: "50vh",
            overflow: "scroll",
            paddingBottom: "50px",
          }}
        >
          {songs && songs["songs"].length > 0
            ? songs["songs"].map((song, index) => (
                <Box
                  sx={{
                    position: "relative",
                  }}
                  key={index}
                >
                  <MusicRow
                    index={index}
                    playingIndex={playingIndex}
                    play={true}
                    music={song}
                    handleOpen={() => toggleDrawer(true, null, index)}
                    onRedirect={(path) => onRedirect(path)}
                    playSongs={() =>
                      dispatch(
                        addSongAction(song, song["playListId"], false)
                        // addSongsAction(
                        //   songs["songs"],
                        //   false,
                        //   song["playListId"],
                        //   index
                        // )
                      )
                    }
                  />
                  {index === selectedIndex && open ? (
                    <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
                      <DropMenu
                        right={"0px"}
                        open={open}
                        color="#000000"
                        actions={[
                          { key: "m3", action: t("dropMenu.m3") },
                          // { key: "m2", action: t("dropMenu.m2") },
                          { key: "m25", action: t("dropMenu.m25") },
                        ]}
                        toggleMenu={(action) =>
                          toggleDrawer(action, song._id, index)
                        }
                      />
                    </OutsideClickHandler>
                  ) : null}
                </Box>
              ))
            : null}
        </Stack>
      </Box>
      {/* <BottomSheet
        open={open}
        actions={[
          "Add to Studio",
          "View Song Information",
          "Remove song from Queue",
        ]}
        handleOpen={toggleDrawer}
      /> */}
      {/* {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={selectedId}
          open={showPlaylist}
          handleClose={() => setShowPlaylist(false)}
        />
      ) : null} */}
    </Box>
  );
}
